<!--SOF Header-->
<header [class]="userAccess == 2 ? 'header' : 'header header-user-landing'">
  <a *ngIf="userAccess == 2" class="nav-icon" (click)="navShowHide()" style="cursor: pointer;">
  </a>
  <div class="brand">
    <a [routerLink]='["/dashboard"]'><img src="../../assets/images/logo.png" width="137px" /></a>
  </div>
  <div class="head-right">
    <ul class="right-list pull-right">
      <li class="user-welcome dropdown">
        <!-- (click)="showHideUserDropdown()" -->
        <a id="user" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="cursor: pointer;">
          <span>Welcome <b>{{userName}}</b></span><i class="fa fa-user-o"></i>
          <span style="display:none;" class="fa fa-angle-down"></span>
        </a>
        <div class="dropdown-menu" aria-labelledby="user">
          <a class="dropdown-item" href="javascript:void(0)">
            Action
          </a>
          <a class="dropdown-item" href="javascript:void(0)">
            Another action
          </a>
          <a class="dropdown-item" href="javascript:void(0)">
            Something else here
          </a>
          <a class="dropdown-item" href="javascript:void(0)">
            Separated link
          </a>
        </div>
      </li>
      <li class="logout error-tooltip">
        <a style="cursor: pointer;" [routerLink]='["/logout"]'>
        </a>
        <span class="error-tooltip-text">Log Out</span>
      </li>
    </ul>

    <ul class="right-list pull-right program-list"
      *ngIf="appConstant.userProgramDatasource && appConstant.userProgramDatasource.length > 0 && appConstant.programId && userAccess == 2">
      <li [class]="className" id="liprogramheader">
        <a href="javascript:void(0)" class="" id="ddlprogramheader" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <span><b>{{appConstant.selectedHeaderProgramText}}</b></span>
          <span class="fa fa-angle-down"></span>
        </a>
        <div class="dropdown-menu" aria-labelledby="user">
          <a *ngFor="let userProgramItem of appConstant.userProgramDatasource; let itemIndex = index"
            class="dropdown-item" (click)="headerProgramChange(userProgramItem.programID, userProgramItem.name)"
            href="javascript:void(0)">
            {{userProgramItem.name}}
          </a>
        </div>
      </li>
      <li class="backto-admin" *ngIf="appConstant.userDetail.roleContext == appConstant.roleContext.Admin">
        <a style="cursor: pointer;" (click)="backToAdmin()"><i class="fa fa-unlock"></i>
          <span> Back to Admin</span>
        </a>
      </li>
    </ul>
  </div>
</header>
<!--EOF Header-->

<!--SOF Left Nav-->
<nav class="asidebar-nav" *ngIf="userAccess == 2">
  <ul class="nav-list">
    <li [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
      <a [routerLink]='["/dashboard"]' (click)="OtherMenuClick()">
        <i class="icon-01"></i><span>Home</span>
      </a>
    </li>
    <li [className]="currentMainMenuLink==appConstant.mainInsightMenu.refId?'link-active':''"
      *ngIf="(appConstant.logInAsProgramContext || appConstant.userDetail.roleContext != appConstant.roleContext.Admin) && appConstant.mainInsightMenu && appConstant.mainInsightMenu.name">
      <a href="javascript:;" (click)="OpenSubMenu()">
        <span *ngIf="appConstant.mainInsightMenu && appConstant.mainInsightMenu.name"><i
            [className]="appConstant.mainInsightMenu.className!=null && appConstant.mainInsightMenu.className!=''?appConstant.mainInsightMenu.className:'icon-08'"></i><span>{{appConstant.mainInsightMenu.name}}</span></span>
      </a>
      <ul class='submenu' *ngIf="subMenuStyle">
        <li *ngFor="let menu of subInsightMenus;"><a [routerLink]='["/insight-menu"]'
            [className]="currentMenuLink==menu.refId?'link-active':''" (click)="LoadDashoardReport(menu)"
            title="{{menu.name}}"><span><i
                [className]="menu.className!=null && menu.className!=''?menu.className:'fa fa-caret-right'"></i><span>{{menu.name}}</span></span></a>
        </li>
      </ul>
    </li>

    <li [className]="currentMainMenuLink==appConstant.adminMenu.refId?'link-active':''"
      *ngIf="(appConstant.logInAsProgramContext || appConstant.userDetail.roleContext != appConstant.roleContext.Admin) && appConstant.adminMenu && appConstant.adminMenu.name">
      <a href="javascript:;" (click)="OpenSubAdminMenu()">
        <span *ngIf="appConstant.adminMenu && appConstant.adminMenu.name"><i
            [className]="appConstant.adminMenu.className!=null && appConstant.adminMenu.className!=''?appConstant.adminMenu.className:'icon-08'"></i><span>{{appConstant.adminMenu.name}}</span></span>
      </a>
      <ul class='submenu' *ngIf="subAdminMenuStyle">
        <li *ngFor="let menu of subAdminMenus;"><a [routerLink]='["/insight-menu"]'
            [className]="currentMenuLink==menu.refId?'link-active':''" (click)="LoadDashoardReport(menu)"
            title="{{menu.name}}"><span><i
                [className]="menu.className!=null && menu.className!=''?menu.className:'fa fa-caret-right'"></i><span>{{menu.name}}</span></span></a>
        </li>
      </ul>
    </li>
    <li [routerLinkActive]='["link-active"]'
      *ngIf="_commonServiceHelper.manageControlSecurity(_commonServiceHelper.moduleNameEnum.Users)">
      <a [routerLink]='["/users"]' (click)="OtherMenuClick()">
        <i class="icon-02"></i><span>Users</span>
      </a>
    </li>
    <li [routerLinkActive]='["link-active"]'
      *ngIf="_commonServiceHelper.manageControlSecurity(_commonServiceHelper.moduleNameEnum.Locations)">
      <a [routerLink]='["/location"]' (click)="OtherMenuClick()">
        <i class="icon-03"></i><span>Locations</span>
      </a>
    </li>
    <li [routerLinkActive]='["link-active"]'
      *ngIf="_commonServiceHelper.manageControlSecurity(_commonServiceHelper.moduleNameEnum.Programs)">
      <a [routerLink]='["/programs"]' (click)="OtherMenuClick()">
        <i class="icon-04"></i><span>Programs</span>
      </a>
    </li>
    <li [routerLinkActive]='["link-active"]'
      *ngIf="_commonServiceHelper.manageControlSecurity(_commonServiceHelper.moduleNameEnum.Sampling_Plans)">
      <a [routerLink]='["/samplingplan"]' (click)="OtherMenuClick()">
        <i class="icon-05"></i><span>Sampling Plans</span>
      </a>
    </li>
    <li [routerLinkActive]='["link-active"]'
      *ngIf="_commonServiceHelper.manageControlSecurity(_commonServiceHelper.moduleNameEnum.Cases)">
      <a [routerLink]='["/cases"]' (click)="OtherMenuClick()">
        <i class="icon-06"></i><span>Cases</span>
      </a>
    </li>

    <li [routerLinkActive]='["link-active"]'
      *ngIf="_commonServiceHelper.manageControlSecurity(_commonServiceHelper.moduleNameEnum.Reports, _commonServiceHelper.moduleActionEnum.View)">
      <a [routerLink]='["/reports"]' (click)="OtherMenuClick()">
        <i class="icon-07"></i><span>Reports</span>
      </a>
    </li>

    <li
      *ngIf="(appConstant.subMarkerInventoryMenus && appConstant.subMarkerInventoryMenus.length>0 && (appConstant.logInAsProgramContext || appConstant.userDetail.roleContext != appConstant.roleContext.Admin))">
      <a href="javascript:;" (click)="OpenMIMSMenu()">
        <i class="icon-08"></i><span>Marker Inventory</span>
      </a>
      <ul class='submenu' *ngIf="subMarkerMenuStyle">
        <li *ngFor="let menu of appConstant.subMarkerInventoryMenus;"
          [className]="currentMenuLink==menu.refId?'link-active':''">
          <a [routerLink]='[menu.link]' [className]="currentMenuLink==menu.refId?'link-active':''"
            (click)="LoadDashoardReport(menu)" title="{{menu.name}}">
            <span>
              <i
                [className]="menu.className!=null && menu.className!=''?menu.className:'fa fa-caret-right'"></i><span>{{menu.name}}</span></span></a>
        </li>

      </ul>
    </li>
  </ul>
</nav>
<!--EOF Left Nav-->

<!--SOF Right Section -->
<section [class]="userAccess == 1 ? 'right-section user-landing' : 'right-section'" (window:resize)="onResize($event)">
  <div *ngIf="userAccess == 2">
    <router-outlet (activate)="changeOfRoutes()"></router-outlet>
  </div>
  <div class="top-title-bar" *ngIf="userAccess == 1 && appConstant.isUserAuthorizeCallCompleted">
    <h2 class="page-title">{{ userProgramDatasource.length > 0 ? 'Select Program' : 'Un-Authorize access, please
      contact your system administrator.'}}</h2>
  </div>
  <div class="white-box" *ngIf="userAccess == 1 && userProgramDatasource.length > 0">
    <div class="assign-module-section">
      <mat-radio-group name="userProgramList" [(ngModel)]="selectedProgramId">
        <ul>
          <li *ngFor="let userProgramItem of userProgramDatasource; let itemIndex = index">
            <div class="ams-box">
              <span class="box-label">{{userProgramItem.name}}</span>
              <div class="checkbox-wrap">
                <mat-radio-button class="user-landing-label" [value]="userProgramItem.programID"
                  [attr.value]="userProgramItem.programID"></mat-radio-button>
              </div>
            </div>
          </li>
        </ul>
      </mat-radio-group>
    </div>
    <div class="btn-groups clearfix">
      <input class="btn btn-ornge pull-right" type="button" [disabled]="!selectedProgramId"
        (click)="programSelectionClick()" value="Continue">
    </div>
  </div>
</section>
<!--EOF Right Section -->

<footer [class]="userAccess == 1 ? 'site-footer user-landing' : 'site-footer'"> © {{currentYear}} Authentix, Inc. All
  Rights
  Reserved. </footer>
